import { render } from "./ManuelleRueckforderung.pug?vue&type=template&id=ff1a9ee4&lang=pug"
import script from "./ManuelleRueckforderung.js?vue&type=script&lang=js"
export * from "./ManuelleRueckforderung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__